import script from "./WriterActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./WriterActions.vue?vue&type=script&setup=true&lang=ts"

import "./WriterActions.vue?vue&type=style&index=0&id=16c193c4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16c193c4"]])

export default __exports__